import { PAGE_PATHS } from '@/app/constants/pages';
import PeriodInitializer from '@/components/periodDetails/PeriodInitializer';
import { PeriodProvider } from '@/context/PeriodContext';
import Admin from '@/pages/admin';
import Redirect from '@/pages/redirecting';
import PERMISSION_ROLES, { PAGE_NAMES } from '@constants/roles';
import RequireAuth from '@features/auth/RequireAuth';
import RequireLogin from '@features/auth/RequireLogin';
import Layout from '@pages/layout';
import Login from '@pages/login';

import AllocationPriority from '@/pages/allocationPriority';
import AvaliablePercentage from '@/pages/avaliablePercentage';
import OverheadBreadcrumb from '@/pages/Breadcrumb/OverheadBreadcrumb';
import ProvidersBreadcrumb from '@/pages/Breadcrumb/ProvidersBreadcrumb';
import ConsiderCollaborator from '@/pages/considerCollaborator';
import FinalVersion from '@/pages/finalVersion';
import General from '@/pages/general';
import Overhead from '@/pages/overhead';
import OverheadDetails from '@/pages/overheadDetails';
import PeriodDetailsPage from '@/pages/periodDetails';
import PositionRestriction from '@/pages/PositionRestriction';
import ProjectPriority from '@/pages/projectPriority';
import Providers from '@/pages/providers';
import ProvidersDetails from '@/pages/providersDetails';
import ResourceDonors from '@/pages/resourceDonors';
import SpecificAllocation from '@/pages/specificAllocation';

import { BranchProvider } from '@/context/BranchsContext';
import UploadHistoric from '@/pages/historic';
import { Route, Routes } from 'react-router-dom';
import ExtraCollaborator from '@/pages/extraCollaborator';
import AllocationConstraint from '@/pages/allocationConstraint';
import DisregardEvents from '@/pages/disregardEvents';

function AppRoute() {
  return (
    <PeriodProvider>
      <BranchProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireLogin />}>
            <Route element={<PeriodInitializer />}>
              <Route element={<Layout />}>
                {/* public routes */}
                <Route path="/" element={<Redirect />} />
                <Route path={PAGE_PATHS.GENERAL} element={<General />} />
                <Route path={PAGE_PATHS.CONSIDERCOLLABORATOR} element={<ConsiderCollaborator />} />
                <Route path={PAGE_PATHS.DISREGARDEVENTS} element={<DisregardEvents />} />
                <Route element={<PeriodDetailsPage />}>
                  <Route element={<ProvidersBreadcrumb />}>
                    <Route path="/providers/:id" element={<ProvidersDetails />} />{' '}
                    <Route path={PAGE_PATHS.PROVIDERS} element={<Providers />} />
                  </Route>
                </Route>
                <Route element={<PeriodDetailsPage />}>
                  <Route element={<OverheadBreadcrumb />}>
                    <Route path="/overhead/:id" element={<OverheadDetails />} />{' '}
                    <Route path={PAGE_PATHS.OVERHEAD} element={<Overhead />} />
                  </Route>
                </Route>
                <Route path={PAGE_PATHS.FINALVERSION} element={<FinalVersion />} />
                <Route path={PAGE_PATHS.AVAILABLEPERCENTAGE} element={<AvaliablePercentage />} />
                <Route path={PAGE_PATHS.PROJECTPRIORITY} element={<ProjectPriority />} />
                <Route path={PAGE_PATHS.RESOURCEDONORS} element={<ResourceDonors />} />
                <Route path={PAGE_PATHS.SPECIFICALLOCATION} element={<SpecificAllocation />} />
                <Route path={PAGE_PATHS.ALLOCATIONPRIORITY} element={<AllocationPriority />} />
                <Route path={PAGE_PATHS.POSITIONRESTRICTION} element={<PositionRestriction />} />
                <Route path={PAGE_PATHS.ALLOCATIONCONSTRAINT} element={<AllocationConstraint />} />
                <Route path={PAGE_PATHS.UPLOADHISTORIC} element={<UploadHistoric />} />
                <Route path={PAGE_PATHS.EXTRACOLLABORATOR} element={<ExtraCollaborator />} />
                {/* protected routes for ADMIN */}
                <Route element={<RequireAuth roles={PERMISSION_ROLES[PAGE_NAMES.ADMIN]} />}>
                  <Route path={PAGE_PATHS.PROFILE} element={<Admin />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Routes>
      </BranchProvider>
    </PeriodProvider>
  );
}

export default AppRoute;
